import React from "react";
import ExternalLegalRedirect from "../../components/common/ExternalLegalRedirect";
import { QIKTRUCK_TERMS_URL } from "../../constants/legal";

export default function TermsRedirect() {
  return (
    <ExternalLegalRedirect url={QIKTRUCK_TERMS_URL} label="Terms and Conditions" />
  );
}
